'use client'
import styled from "styled-components";
import {Black, primary} from "@/styles/globalStyleVars";
import {Col, Container, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import SectionTitle from "@/components/SectionTitle";
import SubTitle from "@/components/SubTitle";
import Description from "@/components/Description";
import {useEffect} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";
import {usePathname} from "next/navigation";


const MyComponent = ({upper_text,lower_text,section_title,subtitle,desc}) => {
    ScrollTrigger.refresh();
    gsap.registerPlugin(ScrollTrigger);
    const pathname =usePathname();
    useEffect(() => {
        gsap.to('.scroll-left', {
            x: '-100%',
            duration: .6,
            scrollTrigger: {
                scrub: 2
            }
        })
        gsap.to('.scroll-right', {
            x: '100%',
            duration: .6,
            scrollTrigger: {
                scrub: 2
            }
        })
    }, [pathname])
     return (
        <StyledComponent className={"pt-100 pb-100 service-overview"} id={'overview'}>
            <div className="fixed-img scroll-left">
                <p>{upper_text}</p>
            </div>
            <div className="fixed-img scroll-right fixed-img-v">
                <p>{lower_text}</p>
            </div>
            <Container>
                <SectionTitle text={section_title} color={primary} border={'rgba(255,255,255,0.2)'}/>
                <Row className={'overview-row'}>
                    <Col md={6}>
                        <SubTitle
                            text={subtitle}
                            color={'#FFF'} fontSize={'40'} lineHeight={50} fontWeight={'300'}/>
                    </Col>
                    <Col md={{offset:2,span:4}}>
                        <Description text={desc} color={'#FFF'}/>
                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    );

};

const StyledComponent = styled.section`
    background-color: #3C3C3B;
    position: relative;
    overflow: hidden;
    h3 {
        font-weight: 300;
    }

    @media (max-width: 991px) {
        .overview-row {
            flex-direction: column;
            .col-md-6, .col-md-4{
                max-width: 100%;
            }
            .offset-md-2{
                margin-left: 0;
            }
            
            h3{
                font-size: 28px;
                line-height: 36px;
            }
        }
    }
    @media (max-width: 767px) {
        .overview-row {
            flex-direction: column;
        }
    }

    .fixed-img {
        position: absolute;
        right: 0;
        top: 30%;

        &.fixed-img-v {
            right: unset;
            left: 0;
            top: 60%
        }

        p {
            font-size: 180px;
            line-height: 146px;
            color: rgba(255, 255, 255, 0.05);
            font-weight: 800;
        }
    }
    @media(min-width: 1920px){
        h3{
            font-size: 42px;
            line-height: 50px;
        }
    }
`;

export default MyComponent;
